import type { CardDefinitionDto } from "../../types/CardDefinitionDto";
import type { CardDefinitionEntity } from "../../types/CardDefinitionEntity";

export const CardDefinitionDtoToEntity = ({ ...rest }: Readonly<CardDefinitionDto>): CardDefinitionEntity => {
    return { ...rest };
};
